import { createApiRef, DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { ResponseError } from '@backstage/errors';
import { MyDaySummary } from '@internal/backstage-plugin-my-day-common';

/**
 * Client for the my-day backend.
 *
 * @public
 */
export interface MyDayApi {
  /**
   * Summary for the signed-in user. `refresh` bypasses the server cache
   * (rate-limited by the backend).
   */
  getSummary(options?: { refresh?: boolean }): Promise<MyDaySummary>;
}

/** @public */
export const myDayApiRef = createApiRef<MyDayApi>({
  id: 'plugin.my-day.service',
});

/** @public */
export class MyDayClient implements MyDayApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: { discoveryApi: DiscoveryApi; fetchApi: FetchApi }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  async getSummary(options: { refresh?: boolean } = {}): Promise<MyDaySummary> {
    const baseUrl = await this.discoveryApi.getBaseUrl('my-day');
    const response = await this.fetchApi.fetch(
      `${baseUrl}/summary${options.refresh ? '?refresh=true' : ''}`,
    );
    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }
    return (await response.json()) as MyDaySummary;
  }
}
